const SECURITY_KEY = process.env.REACT_APP_SECURITY_KEY;
const themeDefault = 'dark'
const namesOfModes = ['dark', 'moonlight', 'eclipse', 'light']

const BASE_URL = process.env.REACT_APP_BASE_URL;
const GAMES_API_BASE_URL = process.env.REACT_APP_GAMES_API_BASE_URL;

const TIMES_TABLE_APP_URL = process.env.REACT_APP_TIMES_TABLE_APP_URL;
export { SECURITY_KEY, themeDefault, namesOfModes, BASE_URL, TIMES_TABLE_APP_URL, GAMES_API_BASE_URL }